import React, { useState, useEffect, useRef } from 'react';
import './DetailPageHero.css';

const DetailPageHero = ({
  src,
  alt,
  lazy = true,
  title,
  noMargin = false,
  adaptiveAspectRatio = true,
  ...props
}) => {
  const [shouldRender, setShouldRender] = useState(!lazy);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [aspectRatio, setAspectRatio] = useState(null);
  const containerRef = useRef();

  useEffect(() => {
    if (!lazy) {
      setShouldRender(true);
      return;
    }

    const node = containerRef.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShouldRender(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '200px 0px',
        threshold: 0.01
      }
    );

    if (node) {
      observer.observe(node);
    }

    return () => {
      if (observer && node) {
        observer.unobserve(node);
      }
    };
  }, [lazy]);

  const handleImageLoad = (event) => {
    setHasLoaded(true);

    if (!adaptiveAspectRatio || aspectRatio) {
      return;
    }

    const { naturalWidth, naturalHeight } = event.target;
    if (naturalWidth && naturalHeight) {
      setAspectRatio(naturalWidth / naturalHeight);
    }
  };

  return (
    <div
      className={`detail-page-hero-container${noMargin ? ' no-margin' : ''}${adaptiveAspectRatio ? ' adaptive-aspect' : ''}`}
      ref={containerRef}
      style={adaptiveAspectRatio ? { '--detail-page-hero-aspect': aspectRatio ? `${aspectRatio}` : '16 / 9' } : undefined}
    >
      {shouldRender && (
        <>
          {/* Upscaled, blurred copy bleeding out from behind the hero. Only for
              eagerly-loaded heroes, matching the original. */}
          {!lazy && (
            <img
              src={src}
              alt=""
              aria-hidden="true"
              {...props}
              onLoad={handleImageLoad}
              style={{ opacity: hasLoaded ? 'var(--hero-glow-opacity)' : 0 }}
              className="detail-page-hero-image-blur"
            />
          )}

          <img
            src={src}
            alt={alt}
            {...props}
            onLoad={handleImageLoad}
            style={{ opacity: hasLoaded ? 1 : 0 }}
            className="detail-page-hero-image"
          />

          {title && (
            <>
              <div className='detail-page-hero-scrim'></div>
              <div className='detail-page-hero-header'>{title}</div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default DetailPageHero;
